import styled from "styled-components";
import { Grid } from "@material-ui/core";

export const STGrid = styled(Grid)`
  height: 100vh;
`;
